// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AddonController from './addon_controller';
application.register('addon', AddonController);

import AddressAutofillController from './address_autofill_controller';
application.register('address-autofill', AddressAutofillController);

import AutocompleteB2bContactPersonController from './autocomplete_b2b_contact_person_controller';
application.register(
  'autocomplete-b2b-contact-person',
  AutocompleteB2bContactPersonController
);

import AutocompletePlacesController from './autocomplete_places_controller';
application.register('autocomplete-places', AutocompletePlacesController);

import B2bPhotoSelectionController from './b2b_photo_selection_controller';
application.register('b2b-photo-selection', B2bPhotoSelectionController);

import B2bPhotoSelectionShootingController from './b2b_photo_selection_shooting_controller';
application.register('b2b-photo-selection-shooting', B2bPhotoSelectionShootingController);

import BasketFreezeController from './basket_freeze_controller';
application.register('basket-freeze', BasketFreezeController);

import BookingProcess__ShootingDateController from './booking_process/shooting_date_controller';
application.register(
  'booking-process--shooting-date',
  BookingProcess__ShootingDateController
);

import BookingProcess__StudioSelectController from './booking_process/studio_select_controller';
application.register(
  'booking-process--studio-select',
  BookingProcess__StudioSelectController
);

import CartController from './cart_controller';
application.register('cart', CartController);

import ClipboardCopyController from './clipboard_copy_controller';
application.register('clipboard-copy', ClipboardCopyController);

import CollectionCounterController from './collection_counter_controller';
application.register('collection-counter', CollectionCounterController);

import DirectUploadController from './direct_upload_controller';
application.register('direct-upload', DirectUploadController);

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import DropzoneController from './dropzone_controller';
application.register('dropzone', DropzoneController);

import EatmsController from './eatms_controller';
application.register('eatms', EatmsController);

import EbasketController from './ebasket_controller';
application.register('ebasket', EbasketController);

import FlatpickrController from './flatpickr_controller';
application.register('flatpickr', FlatpickrController);

import FormUpdatePartialController from './form_update_partial_controller';
application.register('form-update-partial', FormUpdatePartialController);

import Freelancer__ApplicationSubmitDisabledToggleController from './freelancer/application_submit_disabled_toggle_controller';
application.register(
  'freelancer--application-submit-disabled-toggle',
  Freelancer__ApplicationSubmitDisabledToggleController
);

import Freelancer__CategorySelectController from './freelancer/category_select_controller';
application.register('freelancer--category-select', Freelancer__CategorySelectController);

import FreelancerLocationController from './freelancer_location_controller';
application.register('freelancer-location', FreelancerLocationController);

import FriendlyCaptchaController from './friendly_captcha_controller';
application.register('friendly-captcha', FriendlyCaptchaController);

import GalleryController from './gallery_controller';
application.register('gallery', GalleryController);

import GeolocationController from './geolocation_controller';
application.register('geolocation', GeolocationController);

import HistoryController from './history_controller';
application.register('history', HistoryController);

import InputDisabledToggleController from './input_disabled_toggle_controller';
application.register('input-disabled-toggle', InputDisabledToggleController);

import KpisFullscreenController from './kpis_fullscreen_controller';
application.register('kpis-fullscreen', KpisFullscreenController);

import KpisLiveRefreshController from './kpis_live_refresh_controller';
application.register('kpis-live-refresh', KpisLiveRefreshController);

import LayoutController from './layout_controller';
application.register('layout', LayoutController);

import LocationController from './location_controller';
application.register('location', LocationController);

import LoginController from './login_controller';
application.register('login', LoginController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import MoveElementController from './move_element_controller';
application.register('move-element', MoveElementController);

import MultiSelectController from './multi_select_controller';
application.register('multi-select', MultiSelectController);

import NavigationController from './navigation_controller';
application.register('navigation', NavigationController);

import PaypalController from './paypal_controller';
application.register('paypal', PaypalController);

import PaypalBookingController from './paypal_booking_controller';
application.register('paypal-booking', PaypalBookingController);

import PhotoSelectionController from './photo_selection_controller';
application.register('photo-selection', PhotoSelectionController);

import PointOfSaleAutoLogoutController from './point_of_sale_auto_logout_controller';
application.register('point-of-sale-auto-logout', PointOfSaleAutoLogoutController);

import ReloadController from './reload_controller';
application.register('reload', ReloadController);

import ResetFormController from './reset_form_controller';
application.register('reset-form', ResetFormController);

import SalesTargetFormController from './sales_target_form_controller';
application.register('sales-target-form', SalesTargetFormController);

import SearchController from './search_controller';
application.register('search', SearchController);

import SidePanelController from './side_panel_controller';
application.register('side-panel', SidePanelController);

import SimpleFormDropzoneController from './simple_form_dropzone_controller';
application.register('simple-form-dropzone', SimpleFormDropzoneController);

import SortableGroupsController from './sortable_groups_controller';
application.register('sortable-groups', SortableGroupsController);

import SortableTableController from './sortable_table_controller';
application.register('sortable-table', SortableTableController);

import StaffAddShootingDateController from './staff_add_shooting_date_controller';
application.register('staff-add-shooting-date', StaffAddShootingDateController);

import StaffCartCreationController from './staff_cart_creation_controller';
application.register('staff-cart-creation', StaffCartCreationController);

import StaffStudioCalendarController from './staff_studio_calendar_controller';
application.register('staff-studio-calendar', StaffStudioCalendarController);

import TableController from './table_controller';
application.register('table', TableController);

import TagifyController from './tagify_controller';
application.register('tagify', TagifyController);

import TailSelectController from './tail_select_controller';
application.register('tail-select', TailSelectController);

import ToastController from './toast_controller';
application.register('toast', ToastController);

import ToggleInfoController from './toggle_info_controller';
application.register('toggle-info', ToggleInfoController);

import ToggleModalController from './toggle_modal_controller';
application.register('toggle-modal', ToggleModalController);

import ToggleVisibilityController from './toggle_visibility_controller';
application.register('toggle-visibility', ToggleVisibilityController);

import TopnavController from './topnav_controller';
application.register('topnav', TopnavController);

import TreeController from './tree_controller';
application.register('tree', TreeController);

import Website__DropdownController from './website/dropdown_controller';
application.register('website--dropdown', Website__DropdownController);

import Website__GalleryController from './website/gallery_controller';
application.register('website--gallery', Website__GalleryController);

import Website__HeadlineMarkerController from './website/headline_marker_controller';
application.register('website--headline-marker', Website__HeadlineMarkerController);

import Website__ScrollTopButtonController from './website/scroll_top_button_controller';
application.register('website--scroll-top-button', Website__ScrollTopButtonController);

import Website__TabsController from './website/tabs_controller';
application.register('website--tabs', Website__TabsController);

import Website__TeaserRowController from './website/teaser_row_controller';
application.register('website--teaser-row', Website__TeaserRowController);

import Website__ToastController from './website/toast_controller';
application.register('website--toast', Website__ToastController);

import SupportRequestController from './support_request_controller';
application.register('support-request', SupportRequestController);

import OffStudioToggleController from './off_studio_toggle_controller';
application.register('off-studio-toggle', OffStudioToggleController);

import BookingCalendarController from './booking_calendar_controller';
application.register('booking-calendar', BookingCalendarController);

import AccountToggleController from './account_toggle_controller';
application.register('account-toggle', AccountToggleController);

import StudioAutocompleteController from './studio_autocomplete_controller';
application.register('studio-autocomplete', StudioAutocompleteController);

import RecommendationsController from './recommendations_controller';
application.register('recommendations', RecommendationsController);

import AccessCodeTypeController from './access_code_type_controller';
application.register('access-code-type', AccessCodeTypeController);

import CategoryFilterController from './category_filter_controller';
application.register('category-filter', CategoryFilterController);
